import React from "react";
import { X } from "lucide-react";

interface LeftDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  icon?: React.ReactNode;
  width?: string;
  children: React.ReactNode;
}

const LeftDrawer: React.FC<LeftDrawerProps> = ({
  isOpen,
  onClose,
  title,
  icon,
  width = "420px",
  children,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black/40 z-40 transition-opacity"
        onClick={onClose}
      />

      <div
        className="fixed top-0 right-0 h-full bg-white dark:bg-gray-900 shadow-2xl z-50 flex flex-col overflow-hidden animate-[slideInLeft_0.2s_ease-out]"
        style={{ width, maxWidth: "100%" }}
      >
        <div className="flex items-center justify-between border-b border-gray-200 dark:border-gray-700 px-6 py-4 bg-white dark:bg-gray-900 shrink-0">
          <h2 className="flex items-center gap-2 text-lg font-semibold text-gray-900 dark:text-gray-100 truncate">
            {icon}
            {title}
          </h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto">{children}</div>
      </div>

      <style>{`
        @keyframes slideInLeft {
          from { transform: translateX(-100%); }
          to { transform: translateX(0); }
        }
      `}</style>
    </>
  );
};

export default LeftDrawer;
